import * as React from "react";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

import { Blog } from "./Blog";

export interface Props {
  blog: Blog;
  onClick: () => void;
}

export const BlogListEntry = (props: Props) => {
  const {
    blog: { title, teaser, teaserTitle, teaserImage, created },
    onClick,
  } = props;

  return (
    <Card elevation={1}>
      <CardActionArea onClick={onClick}>
        {teaserImage && (
          <CardMedia
            image={teaserImage}
            style={{
              height: 240,
              backgroundSize: "contain",
              marginLeft: 16,
              marginRight: 16,
            }}
          />
        )}
        <CardContent>
          <Typography variant="h6" color="textPrimary" gutterBottom={true}>
            {teaserTitle ?? title}
          </Typography>
          <Typography variant="body1" color="textSecondary" component="p">
            {teaser}
          </Typography>
        </CardContent>
        <Box
          display="flex"
          flexGrow={1}
          flexShrink={1}
          flexBasis="100%"
          justifyContent="center"
          m={2}
        >
          <Box flexGrow={0} flexShrink={0}>
            <Avatar
              color="primary"
              style={{ width: 24, height: 24, fontSize: 13, fontWeight: 700 }}
            >
              QF
            </Avatar>
          </Box>
          <Box flexGrow={1} flexShrink={1} mx={2}>
            <Typography variant="body1" color="textSecondary">
              Quantifiction Team
            </Typography>
          </Box>
          <Box flexGrow={0} flexShrink={0}>
            <Typography variant="body1" color="textSecondary">
              {created.toLocaleDateString("en", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </Typography>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/components/Blog/BlogListEntry.tsx